import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: window.localStorage.getItem('user') ?
      JSON.parse(window.localStorage.getItem('user')) : {
        id: 0,
        fullName: null,
        email: '',
        password: null,
        lang: 'english',
        expired: 0,
        customerId: null,
        street: null,
        city: null,
        state: null,
        country: null,
        zipCode: null,
        taxId: null,
        extraInfomation: null,
        memberShip:"free",
        profilePicture: null
      },
    token: window.localStorage.getItem('token') ?
      JSON.parse(window.localStorage.getItem('token')) : null
  },
  reducers: {
    setAuthField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setUser(state, action) {
      state.user = action.payload
      window.localStorage.setItem('user', JSON.stringify(action.payload))
    },
    setToken(state, action) {
      state.token = action.payload
      window.localStorage.setItem('token', JSON.stringify(action.payload))
    },
    initializeAuthFields(state) {
      state.id = 0
      state.fullName = null
      state.email = ''
      state.password = null
      state.lang = 'english'
      state.expired = 0
      state.customerId = null
      state.street = null
      state.city = null
      state.state = null
      state.country = null
      state.zipCode = null
      state.taxId = null
      state.extraInfomation = null
      state.memberShip="free"
      state.profilePicture = null
    }
  }
})

export const {
  setUser,
  setAuthField,
  setToken,
  initializeAuthFields
} = userSlice.actions
export default userSlice.reducer